import {
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import MyTableCell from '../../../components/material-ui/adaptive/MyTableCell';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../store';
import CusLink from '../../../components/material-ui/CusLink';
import TypographyText from '../../../components/material-ui/table/TypographyText';
import { TableRows } from '@mui/icons-material';
import CurrencyValue from '../../../components/material-ui/CurrencyValue';
import RefcodeTableRow from './RefcodeTableRow';
import LoaderContainer from '../../../components/material-ui/loader_container/LoaderContainer';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import ShowContentWitchEmpty from '../../../components/material-ui/show_content_empty/ShowContentWitchEmpty';

export default function ReportRefcodeTable({ loader, empty }) {
  const { t } = useTranslation();
  const refcodeList = useAppSelector((state) => state.reports.refcode.info);
  const refcodeCurrency = useAppSelector((state) => state.reports.refcode.payload?.currency);
  const groupHash = useAppSelector((state) => state.user.group.hash);
  const [hoverIndex, setHoverIndex] = useState(null);

  const TableHeadCell = ({ children, text, rowSpan = 2, colSpan }) => {
    return (
      <MyTableCell isLess rowSpan={rowSpan} colSpan={colSpan}>
        {text ? (
          <Typography fontSize={12} lineHeight={'120%'} fontWeight={600} textAlign={'center'}>
            {t(text)}
          </Typography>
        ) : (
          children
        )}
      </MyTableCell>
    );
  };

  return (
    <LoaderContainer loader={loader} isBox>
      <ShowContentWitchEmpty
        condition={refcodeList.length}
        conditionPlug={empty}
        plugText="No entries found. Try changing the filters.">
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeadCell text={'Reference code/Date'} />
                <TableHeadCell text={'Total number of deposits'} />
                <TableHeadCell text={'Number of first deposits'} />
                <TableHeadCell text={'Number of repeat deposits'} />
                <TableHeadCell text={'Number of registrations'} />
                <TableHeadCell text={'First deposits among registered'} rowSpan={1} colSpan={2} />
                <TableHeadCell text={'Amount of the first deposit'} />
                <TableHeadCell text={'Amount of repeat deposit'} />
                <TableHeadCell text={'Total Deposits'} />
                <TableHeadCell text={'Average Deposits'} />
              </TableRow>
              <TableRow>
                <MyTableCell isSmall>{t('Qty')} </MyTableCell>
                <MyTableCell isSmall>{t('Sum')}</MyTableCell>
              </TableRow>
            </TableHead>
            <TableBody className="refcode-table-body">
              {refcodeList.map((refcode, refcodeIndx) => {
                const isHoverIndx = hoverIndex === refcodeIndx;

                return (
                  <RefcodeTableRow
                    key={refcodeIndx}
                    refcode={refcode}
                    refcodeIndx={refcodeIndx}
                    isHoverIndx={isHoverIndx}
                    setHoverIndex={setHoverIndex}
                  />
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </ShowContentWitchEmpty>
    </LoaderContainer>
  );
}
